


























































import { Vue, Component } from 'vue-property-decorator';
import { save, ifSave, getBaseInfo, rank, getUserInfo } from '../api';
import Poster from '../components/Poster.vue';
import { Toast } from 'vant';

Vue.use(Toast);
@Component({
  components: {
    Poster,
  },
})
export default class Apply extends Vue {
  userInfo: any = {};
  baseInfo: any = {};
  showApplyBtn: boolean = true;
  rankData: any = {};
  get udid() {
    return window.udid;
  }
  get showBtnCondition() {
    return {
      appliedBtn: this.udid && !this.showApplyBtn,
      applyBtn: (!this.udid || this.showApplyBtn) && this.inApplyTime,
      closedBtn: (!this.udid || this.showApplyBtn) && !this.inApplyTime,
    };
  }
  get inApplyTime() {
    return Date.now() < this.baseInfo.endTime * 1000;
  }
  get isSignUp() {
    return this.showApplyBtn;
  }
  // 生成邀请链接
  get inviteUrl() {
    return (location.href + '?id=' + this.userInfo).replace(
      'apply',
      'inviteApply',
    );
  }
  get showData() {
    let flag = false;
    for (const item in this.rankData) {
      if (Object.prototype.hasOwnProperty.call(this.rankData, item)) {
        const element = this.rankData[item];
        if (element !== 0) {
          flag = true;
          break;
        }
      }
    }
    if (flag) {
      return this.rankData;
    } else {
      return false;
    }
  }
  async created() {
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    const user: any = await getUserInfo();
    this.userInfo = user.data;

    const resp: any = await getBaseInfo();
    if (resp.code === 200) {
      this.baseInfo = resp.data;
    }

    const res: any = await ifSave();
    const diff = this.baseInfo.endTime * 1000 > Date.now() && res.code === 203;
    if (res.code === 200 || diff) {
      this.showApplyBtn = true;
    } else {
      this.showApplyBtn = false;
    }

    const ret: any = await rank();
    if (ret.code === 200) {
      this.rankData = ret.data;
    }
  }

  async handleClickApply() {
    if (!window.udid) {
      Toast('请登陆上游账号');
      return;
    }
    if (window.gettoken() && window.gettoken() !== 'null') {
      // 判断当前报名时间
      const startT = this.baseInfo.startTime * 1000;
      const endT = this.baseInfo.endTime * 1000;
      const now = Date.now();
      if (now < startT) {
        Toast('报名未开始');
        return;
      }

      const res: any = await save();
      Toast(res.msg);
      if (res.code === 200) {
        setTimeout(() => {
          this.$router.go(0);
        }, 500);
      }
    } else {
      this.inAppAlertLogin();
    }
  }

  async handleClickInvite() {
    if (!window.udid) {
      Toast('请登陆上游账号');
      return;
    }
    const token = window.gettoken();
    if (window.udid && (token === 'null' || !token)) {
      this.inAppAlertLogin();
      return;
    }
    if (this.isSignUp) {
      Toast('请先报名参加活动');
      return;
    }
    this.$router.push({
      path: 'invitation-share',
      query: {
        inviteUrl: encodeURIComponent(this.inviteUrl),
      },
    });
  }

  inAppAlertLogin() {
    if (parseFloat(window.version) >= 4.5) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
    } else {
      window.location.href = 'client:logout';
    }
  }
}
